import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import DatePicker from "./DatePicker";
var TimePicker = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DatePicker, _extends({}, props, {
    picker: "time",
    mode: undefined,
    ref: ref
  }));
});
TimePicker.displayName = "TimePicker";
export default TimePicker;